<div>
	<div class="panel-section">
		<panel-info-bar [infoData]="infoData" (click)="toggleExpand()" />
		<div class="log-container" [hidden]="!expanded">
			<communication-log [communicationLog]="taskflowCommunicationLogs" />
		</div>
	</div>
</div>